<template>
  <div :class="['toast', $theme]">
    <div class="toast-content">
      <div class="toast-icon"><svg-icon :name="icon" :size="iconSize" /></div>
      <div class="toast-description" v-if="componentName">
        <component :is="componentName" v-bind="componentProps" @close="$emit('close')" />
      </div>
      <div class="toast-description" v-else v-html="content" />
    </div>
    <div class="clickable-icon close-icon" @click="$emit('close')">
      <svg-icon name="close" :size="15" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'success',
      validator: (value) => {
        return ['success', 'fail', 'warn', 'notification'].indexOf(value) !== -1;
      }
    },
    content: {
      type: String
    },
    componentProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      icons: {
        success: 'circle-check',
        warn: 'info',
        fail: 'circle-x',
        notification: 'bell'
      }
    };
  },
  computed: {
    iconSize() {
      return this.variant === 'notification' ? 30 : 20;
    },
    componentName() {
      return this.variant === 'notification' ? 'notification-toast' : null;
    },
    icon() {
      return this.icons[this.variant];
    }
  }
};
</script>

<style lang="scss" scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 50000;
  padding: 15px 24px;
  border-radius: 100px;
  box-shadow: var(--shadow);
  animation: 5s slide-and-leave ease-in forwards;
  overflow: hidden;
  background: #ffffff;
  margin: 0 auto;

  &.dark {
    background: var(--secondary);
  }

  &-content {
    display: flex;
    align-items: center;
  }

  &-description {
    margin: 0 12px;
  }

  .close-icon {
    justify-self: flex-end;
    width: 24px;
    height: 24px;
  }
}
</style>
